module.exports = __webpack_public_path__ + "img/flag_my.149d8ce.png";